//#region src/theme/mobileChrome.ts
var e = 60, t = 64;
//#endregion
export { t as MOBILE_BOTTOM_BAR, e as MOBILE_TOP_BAR };
